module.exports = __webpack_public_path__ + "img/gt.gtc0bc6c2.svg";